export const homeRoute = '/';
export const registerRoute = '/register';
export const dashboardRoute = '/app/dashboard';
